import { useMemo } from "react";
import { SECTIONS, Section } from "../components/stepper/steps";
import { ConsultationData } from "./useConsultationData";

/**
 * Filters the static SECTIONS list down to what the current client's data
 * supports. Spec §7 — "Data Adaptability".
 *
 * Currently:
 *   - drops Body Composition (sub 2.6) when no InBody data is available
 *   - drops Energy & Training (sub 2.last) when no training-zone data
 *
 * Approval is intentionally NOT a filter here — every system the client has is
 * shown to everyone, and unapproved systems simply hide their score + bar
 * (handled in SystemDetailPanel / SystemsSidebar, mirroring the score screen).
 *
 * Filtering here cascades to the stepper dots (count derived from
 * `section.subs.length`) so the stepper automatically shows the correct
 * number of dots without any extra wiring.
 */
const useAvailableSections = (data: ConsultationData): Section[] =>
  useMemo<Section[]>(() => {
    return SECTIONS.map((section) => {
      if (section.id !== "systems") return section;
      const subs = section.subs.filter((s) => {
        if (s.id === "body-composition") return data.hasInBody;
        if (s.id === "energy-training") return data.hasEnergyTraining;
        return true;
      });
      return { ...section, subs };
    });
  }, [data.hasInBody, data.hasEnergyTraining]);

export default useAvailableSections;
